export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getUserBaseInfo: function getUserBaseInfo(params) {
      return request({
        url: "/admin/user/getUserBaseInfo",
        method: "get",
        params: params
      });
    },
    getFaqList: function getFaqList() {
      return request({
        url: "/api/v3/admin/advisory/category/faq/list",
        method: "get"
      });
    },
    updateFaqInfo: function updateFaqInfo(data) {
      return request({
        url: "/api/v3/admin/advisory/category/faq/edit",
        method: "post",
        data: data
      });
    },
    addFaqInfo: function addFaqInfo(data) {
      return request({
        url: "/api/v3/admin/advisory/category/faq/add",
        method: "post",
        data: data
      });
    },
    delFaqInfo: function delFaqInfo(data) {
      return request({
        url: "/api/v3/admin/advisory/category/faq/delete",
        method: "post",
        data: data
      });
    },
    getFaqAdvisoryList: function getFaqAdvisoryList(params) {
      return request({
        url: "/api/v3/admin/advisory/faq/list",
        method: "get",
        params: params
      });
    },
    updateFaqAdvisory: function updateFaqAdvisory(data) {
      return request({
        url: "/api/v3/admin/advisory/faq/edit",
        method: "post",
        data: data
      });
    },
    addFaqAdvisory: function addFaqAdvisory(data) {
      return request({
        url: "/api/v3/admin/advisory/faq/add",
        method: "post",
        data: data
      });
    },
    delFaqAdvisory: function delFaqAdvisory(data) {
      return request({
        url: "/api/v3/admin/advisory/faq/delete",
        method: "post",
        data: data
      });
    },
    getCategoryList: function getCategoryList() {
      return request({
        url: "/api/v3/admin/advisory/category/list"
      });
    },
    getAdvisoryList: function getAdvisoryList(params) {
      return request({
        url: "/api/v3/admin/advisory/list",
        params: params
      });
    },
    getAdvisoryInfo: function getAdvisoryInfo(params) {
      return request({
        url: "/api/v3/admin/advisory/info",
        params: params
      });
    },
    addReply: function addReply(data) {
      return request({
        url: "/api/v3/admin/advisory/reply",
        method: "post",
        data: data
      });
    },
    closeReply: function closeReply(data) {
      return request({
        url: "/api/v3/admin/advisory/close",
        method: "post",
        data: data
      });
    },
    advisorySearch: function advisorySearch(params) {
      return request({
        url: "/api/v3/admin/faq/search",
        params: params
      });
    },
    faqClick: function faqClick(data) {
      return request({
        url: "/api/v3/admin/faq/click",
        method: "post",
        data: data
      });
    },
    addStar: function addStar(data) {
      return request({
        url: "/api/v3/admin/advisory/star",
        method: "post",
        data: data
      });
    },
    advisoryCount: function advisoryCount() {
      return request({
        url: "/api/v3/admin/advisory/waitCount",
        method: "get"
      });
    }
  };
});